<div class="habit-time-tracker" *ngIf="timers().length > 0">

    @if(timers().length == 1) {

    <div class="flex justify-between items-center" *ngFor="let timer of timers()" role="button"
        (click)="openHabit(timer)">
        <p class="text-16-500 color-12 mb-0">
            {{ habitStore.idToSetup()[timer.setupId].title }}
        </p>

        <p class="text-16-500 color-12">
            {{ timer.totalSecondsSpent | timeFormat }}
            <span *ngIf="timer.totalSeconds">
                / {{ getTotalSeconds(timer) | timeFormat }}
            </span>
        </p>
    </div>

    } @else if(timers().length > 0) {

    <!-- Header -->
    <div class="flex justify-between items-center cursor-pointer timer-header" (click)="toggleTimers()">

        <p class="text-16-500 color-12">{{ ss.t('habitTimer_activeTimers') }}</p>

        <p class="text-10-500 flex items-center justify-center color-7 mb-0 whitespace-nowrap habit-time-count">
            {{ timers().length }}
        </p>
    </div>

    <!-- Expandable Drawer Content -->
    <div class="timer-dropdown-content" [class.timer-dropdown-open]="isExpanded()">
        <div class="timer-list-wrapper">
            <div class="flex justify-between items-center habit-timer-item" *ngFor="let timer of timers()" role="button"
                (click)="openHabit(timer)">

                <div class="flex flex-col">
                    <p class="text-16-500 color-12 mb-0">
                        {{ habitStore.idToSetup()[timer.setupId].title }}
                    </p>

                    <p class="text-14-500 color-12 mb-0">
                        {{ timer.totalSecondsSpent | timeFormat }}
                        <span *ngIf="timer.totalSeconds">
                            / {{ getTotalSeconds(timer) | timeFormat }}
                        </span>
                    </p>
                </div>

                @if(timer.totalSeconds){
                <!-- Progress Circle for Goal-based Time Habits -->
                <div class="timer-progress-circle" [style.background]="getTimerProgressBg(timer)">
                </div>
                }@else{
                <div class="clock-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" style="width: 20px;" width="18" height="18"
                        viewBox="0 0 18 18" fill="none">
                        <path
                            d="M9 0.599609C13.6392 0.59961 17.4004 4.36081 17.4004 9C17.4004 13.6392 13.6392 17.4004 9 17.4004C4.36081 17.4004 0.599609 13.6392 0.599609 9C0.59961 4.36081 4.36081 0.599609 9 0.599609Z"
                            stroke="var(--color12)" stroke-width="1.2" />
                        <path
                            d="M8.96984 10.1321C9.57881 10.1321 10.0725 9.63838 10.0725 9.02941C10.0725 8.42043 9.57881 7.92676 8.96984 7.92676C8.36086 7.86719 8.42043 7.86719 9.02941C7.86719 9.63838 8.36086 10.1321 8.96984 10.1321Z"
                            fill="var(--color12)" />
                        <path class="rotating-hand" d="M9 9L12.75 5.25" stroke="var(--color12)" stroke-width="1.2"
                            stroke-linecap="round" />
                    </svg>
                </div>
                }

            </div>
        </div>
    </div>

    }

</div>

<!-- Backdrop for outside click -->
<div class="timer-backdrop" *ngIf="isExpanded() && timers().length > 0" (click)="toggleTimers()"></div>